// extracted by mini-css-extract-plugin
export var readonly = "_et-1";
export var star = "_et-0";